import { render, staticRenderFns } from "./RetailerProductDetailsModal.vue?vue&type=template&id=038c0e38"
import script from "./RetailerProductDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RetailerProductDetailsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RetailerProductDetailsModal.vue?vue&type=style&index=0&id=038c0e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,RetailerProductModal: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/RetailerProduct/RetailerProductModal.vue').default})
